import { IconCheck, IconEye, IconStar, IconStarFilled, IconUserCircle } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import type { ServiceVendorDto } from '@/services/api/petseo.client.wrapper';

interface ProfileSelectorItemProps {
  profile: ServiceVendorDto;
  isSelected: boolean;
  isDefault: boolean;
  onSelect: () => void;
  onToggleDefault: () => void;
}

export function ProfileSelectorItem({ profile, isSelected, isDefault, onSelect, onToggleDefault }: ProfileSelectorItemProps) {
  const avatarLetter = profile.name?.[0]?.toUpperCase() || 'P';
  const navigate = useNavigate();

  const handleViewClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/profiles/${profile.id}?tab=details`);
  };

  const handleStarClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggleDefault();
  };

  return (
    <button
      type="button"
      className={`dropdown-item d-flex align-items-center gap-2 ${isSelected ? 'active' : ''}`}
      onClick={onSelect}
      style={{
        background: isSelected ? 'var(--tblr-primary-lt)' : 'transparent',
      }}>
      {profile.profilePhotoUrl ? (
        <span className="avatar avatar-sm" style={{ backgroundImage: `url(${profile.profilePhotoUrl})` }} />
      ) : (
        <span className="avatar avatar-sm bg-secondary-lt text-secondary">{profile.name ? avatarLetter : <IconUserCircle size={18} />}</span>
      )}
      <span className="flex-grow-1 fw-medium">{profile.name || 'Bez nazwy'}</span>
      {isSelected && <IconCheck size={18} className="text-primary" />}
      <span
        role="button"
        tabIndex={0}
        onClick={handleViewClick}
        onKeyDown={(e) => e.key === 'Enter' && handleViewClick(e as unknown as React.MouseEvent)}
        title="Edytuj profil"
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        <IconEye size={18} className="text-secondary" />
      </span>
      <span
        role="button"
        tabIndex={0}
        onClick={handleStarClick}
        onKeyDown={(e) => e.key === 'Enter' && handleStarClick(e as unknown as React.MouseEvent)}
        title={isDefault ? 'Usuń domyślny profil' : 'Ustaw jako domyślny'}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        {isDefault ? <IconStarFilled size={18} className="text-warning" /> : <IconStar size={18} className="text-secondary" />}
      </span>
    </button>
  );
}
